export default __webpack_public_path__ + "images/3a70db53a13bdf980238dd646e94866c.svg";